import React from "react";
import { Row, Col } from "react-bootstrap";
import VideoCard from "./VideoCard";

export default function VideoGrid({ videos = [] }) {
  return (
    <Row className="g-3">
      {videos.map((video) => (
        <Col key={video.title} xs={12} md={6} lg={4}>
          <VideoCard video={video} />
        </Col>
      ))}
    </Row>
  );
}
